/** Environment URLs and demo fixtures shared across embed demos. */

/** Registrable domain for session cookies and embed `cookieDomain` / `orCookieDomain`. */
export const COOKIE_DOMAIN = 'shepherd.vet';
export const COOKIE_PREFIX = 'or';

/** Cookie `Domain` attribute as shown in UI copy (leading dot). */
export const COOKIE_SCOPE = `.${COOKIE_DOMAIN}`;

export const HITL_ORIGIN = 'https://hitl.or.staging.shepherd.vet';

export const SDK_API_ORIGIN = 'https://sdkapi.or.staging.shepherd.vet';

export const TOKEN_VALIDATION_URL = `${SDK_API_ORIGIN}/auth/token`;

/** Revoke session token (OneReach SPG staging). */
export const OR_LOGOUT_URL = `${SDK_API_ORIGIN}/auth/token`;

/** POST `{ token: JWT }` — response `{ payload, ttl }` becomes session cookies named from `COOKIE_PREFIX`. */
export const SHEPHERD_VET_AUTH_EXCHANGE_URL =
  `${SDK_API_ORIGIN}/http/1d9e047b-12f1-468e-af39-a8fcf66f0a1b/auth/shepherd-vet`;

/** Mock CRM contacts used by Micro and full-embed demos. */
export const MOCK_CONTACTS = [
  {
    id: '6b5e8cba-530f-4127-b4c6-b45c00f420a3',
    name: 'Andrii Rodrian',
    phone: '+17202392838',
  },
  {
    id: '538a0707-8cb2-446e-b41c-b4aa01727dd1',
    name: 'OR GV1',
    phone: '+17202392661',
  },
  {
    id: '5d1c522f-c27b-4cc6-8ce5-b4c600b4d095',
    name: 'Vlad Voichenko Test',
    phone: '+17204321350 ',
  },
];
